<template>
  <div
    v-focusout="closePaxSelector"
    class="pax-selector-block"
    focus-out-force-open="openPaxSelector"
    @validateInfantCount="validateInfantCount"
    @focus="onPaxClicked"
  >
    <div
      class="pax-count-dropdown"
      @click="onClick"
    >
      <span>{{ passengersTitle }}</span>
    </div>

    <pax-modal
      v-if="paxSelector.dropdown.open"
      :pax-selector="paxSelector"
      :is-young-adults-available="isYoungAdultsAvailable"
      @setAdults="setAdults"
      @setYoungAdults="setYoungAdults"
      @setChildren="setChildren"
      @setInfants="setInfants"
      @clicked="onClosed"
    />
  </div>
</template>

<script>
  import PaxSelectorMixin from 'components/eHorizon/SearchFormMixins/PaxSelector'
  import PaxModal from 'components/eHorizon/PaxSelector/PaxModal'
  import Focusout from 'utils/directives/FocusOut'

  export default {
    directives: {
      Focusout
    },
    components: {
      PaxModal
    },
    mixins: [
      PaxSelectorMixin
    ],
    props: {
      paxSelector: {
        type: Object,
        required: true
      },
      isYoungAdultsAvailable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        passengerTypes: ['adults', 'children', 'infants', 'youngAdults']
      }
    },
    computed: {
      passengersTitle () {
        return this.$t('searchForm.paxSelector.passengers.textEHorizon', { count: this.totalPaxCount }, this.totalPaxCount)
      },
      totalPaxCount () {
        return this.paxSelector.adults + this.paxSelector.children + this.paxSelector.infants + this.paxSelector.youngAdults
      }
    },
    watch: {
      isYoungAdultsAvailable(nValue) {
        if (!nValue) {
          const { adults, youngAdults } = this.paxSelector
          this.setAdults(adults + youngAdults)
          this.setYoungAdults(0)
        }
      }
    },
    methods: {
      onClick () {
        if (!this.paxSelector.dropdown.open) {
          this.onPaxClicked()
        }
      },
      onClosed () {
        if (this.paxSelector.dropdown.open) {
          this.onPaxClicked()
        }
      }
    }
  }
</script>


<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .pax-selector-block {
    border-radius: 3px;
    width: 100%;

    @include bp-mf-desktop {
      position: relative;
      height: 32px;
    }

    .pax-count-dropdown {
      height: 32px;
      position: relative;
      display: flex;
      flex-direction: column;
      background-color: #ffffff;
      border-radius: 3px;
      padding: 0 28px 0 12px;

      &:after {
        color: $grey-default;
        content: $icon-arrow-right-thin-medium;
        @include icon-font-thin();
        position: absolute;
        top: calc(50% - 6px);
        right: 14px;
        transform: rotate(90deg);
        font-size: 12px !important;
        font-weight: 700;
        line-height: 1;
      }

      @include bp-mf-tablet {
        height: 30px;
        background-color: transparent;
      }

      @include bp-mf-desktop {
        margin-bottom: 0;
        border-radius: 0;
        width: 100%;
      }

      span {
        @include text-overflow();
        width: 100%;
        line-height: 32px;
        display: block;
        font-size: em(12);
        color: $blue-dark;
        font-weight: 500;
        background: transparent;

        @include input-placeholder {
          color: $input-placeholder;
        }

        @include bp-mf-tablet {
          line-height: 34px;
        }

        @include bp-mf-desktop {
          font-size: em(12);
          margin-top: 0;
        }
      }
    }

    .pax-content {
      display: flex;
      flex-direction: column;
    }
  }
</style>
